<app-top-bar-wrapper [type]="DashboardType.MY_CAMPAIGNS">
    <app-select-menu campaignSelection
      [iconPath]="'svg/campaign-gray.svg'" [items]="campaignOptions" [placeholder]="'All campaigns'" [showPlaceholderAllSelected]="true"
      class="campaign-select" [control]="campaignControl" [searchable]="true" [width]="'174px'" [showPlaceholderIcon]="true" [selectAllAndClearOptions]="true"
      (onApply)="onCampaignApply()" [selectMode]="SelectMode.MULTI">
    </app-select-menu>
  <app-select-menu creativeSelection [searchable]="true" [showPlaceholderIcon]="true" [selectAllAndClearOptions]="true"
    [iconPath]="'svg/creatives-gray.svg'" [className]="'creative-select'" [control]="creativesControl" [items]="creativesOptions" [width]="'174px'"
    (onApply)="onCreativeApply()" [placeholder]="'All Creatives'" [selectMode]="SelectMode.MULTI" [showPlaceholderAllSelected]="true">
  </app-select-menu>
  <div dashboard class="main-container my-campaigns">
    <app-top-level-metrics></app-top-level-metrics>
    <app-overview-tiles [type]="'campaign'" [overview]="overview" [loading]="loadingState.overview"></app-overview-tiles>
    <div class="widgets-wrapper">
      <div class="widget-container" [attr.data-testid]="DataTestIds.CAMPAIGNS_CONTENT_CATEGORY">
      <app-widget-container 
        [title]="'Performance by Content Category'" [selectDisabled]="!contentCategoryBreakdownValue?.categories?.length"
        [tooltip]="tooltips.contentCategory" [minHeight]="472" [control]="breakdownMetricControl" [selectMode]="SelectMode.SINGLE"
        [selectOptions]="breakdownMetricOptions" [searchable]="false" [selectWidth]="'170px'" [selectAllAndClearOptions]="false" [showRibbon]="showRibbonsAndBanner"
        (apply)="onBreakdownMetricChange()" >
            <app-horizontal-bar-chart [data]="this.contentCategoryBreakdownValue?.categories || []" [loading]="loadingState.contentCategoryBreakdown"
                                      [comparison]="{score: this.contentCategoryBreakdownValue?.campaignShare!}"
                                      [comparisonTitle]="this.campaignBreakdownComparisonTitle"
                                      [colors]="ATTENTION_COLOR_SCALE"
                                      [noDataView]="'svg/no-insights-widget.svg'"
                                      [format]="format" valueField="score" ></app-horizontal-bar-chart>
        </app-widget-container>
      </div>
      <div class="widget-container" [attr.data-testid]="DataTestIds.CAMPAIGNS_LOWEST_SITES">
        <app-widget-container [title]="'Lowest Performing Sites'" [minHeight]="472" [showRibbon]="showRibbonsAndBanner">
            <app-site-performance [data]="lowestSites?.sites || []" [loading]="loadingState.lowestSites" [noDataView]="'svg/no-insights-widget.svg'"></app-site-performance>
        </app-widget-container>
      </div>
    </div>
    <div class="widgets-wrapper refresh-distribution-wrapper">
      <div class="widget-container refresh-distribution-container" [attr.data-testid]="DataTestIds.CAMPAIGNS_REFRESH_RATE">
        <app-widget-container [title]="'Refresh Rate Distribution'"
                              [tooltip]="tooltips.refreshRateDistribution" [showRibbon]="showRibbonsAndBanner">
            <app-refresh-rate-distribution [data]="this.refreshDistribution" [loading]="loadingState.refreshRateDistribution"></app-refresh-rate-distribution>
        </app-widget-container>
      </div>
    </div>
    <div class="table-container">
      <div class="ribbon-container" *ngIf="showRibbonsAndBanner">
        <app-ribbon></app-ribbon>
      </div>
      <div class="table-header-container">
        <div class="table-header">
          <div class="table-header-title">Inventory Quality</div>
          <app-download-widget
            [tooltipText]="tooltips.downloadCsv" [options]="downloadCsvOptions" [onDownloadClick]="boundDownloadHandler">
          </app-download-widget>
        </div>
        <div class="inventory-quality-filters-container" *ngIf="!!inventoryQuality?.total || inventoryQualityWebsiteSearch">
          <app-search-bar
            [searchControl]="inventoryQualityWebsiteSearchTerm" [placeholder]="filterByWebsite" (onSubmitSearch)="onInventoryQualityWebsiteSearch()">
          </app-search-bar>
          <app-select-menu
            [disabled]="!inventoryQuality?.total" [width]="'170px'" [searchable]="true" [showPlaceholderIcon]="true" [selectAllAndClearOptions]="true"
            [iconPath]="'svg/globe.svg'" [className]="'campaign-inventory-select'" [control]="categoriesControl" [showPlaceholderAllSelected]="true"
            [items]="categoriesOptions" (onApply)="onApplyInventoryQualityCategories()" [placeholder]="'All Categories'"
            [selectMode]="SelectMode.MULTI">
          </app-select-menu>
        </div>
      </div>
      <ng-content *ngIf="inventoryQuality?.total || loadingState.inventoryQuality;else noInventoryData">
        <div class="table-content">
          <app-sites-table [columnPrefix]="'Ad'" [tableData]="this.inventoryQuality?.sites || []" [loading]="loadingState.inventoryQuality" (sortChange)="this.onSortInventoryQualityTable($event)"></app-sites-table>
            <app-paginator #inventoryQualityPaginator [length]="this.inventoryQuality?.total || 0"
                          [pageSize]="inventoryQualityPageSize" [initialPage]="inventoryInitialPage"
                          [currentPage]="inventoryCurrentPage"
                          (page)="onInventoryQualityPageChange($event)"
                          [rowControl]="true" [rowsTitle]="rowsPerPage" (rowsChange)="onInventoryQualityRowsChange($event)">
            </app-paginator>
        </div>
        </ng-content>
    </div>
    <div class="banner-container" *ngIf="showRibbonsAndBanner">
      <app-empty-campaigns-banner></app-empty-campaigns-banner>
    </div>
    <ng-template #noInventoryData>
      <app-no-widget-data class="wide-container"></app-no-widget-data>
    </ng-template>
  </div>
</app-top-bar-wrapper>
